<template>
  <div class="content_main">
    <div class="bgone" id="bgone">
      <div class="centerOne">
        <div class="head">
          <div class="firmlogo">
            <div class="firmlogoright">
              <img src="../../assets/img/logo1.svg" alt="" />
            </div>
            <!-- 调取本地邮箱测试用 -->
            <!-- <a href=mailto:sample@163.com>send email</a> -->
          </div>
          <div class="topright">
            <div class="selectleft" id="router">
              <!-- <a :class="{active: active===3}" @click="scrollTo(3)" href="javascript:void(0)"><span class="onespan"> Services </span></a>
                            <a :class="{active: active===4}" @click="scrollTo(4)" href="javascript:void(0)"><span class="onespan"> POD </span></a>
                            <a :class="{active: active===6}" @click="scrollTo(6);changeShow6()" href="javascript:void(0)"><span>Price</span></a>
                            <a :class="{active: active===6}" @click="scrollTo(6);changeShow8()" href="javascript:void(0)"><span> Delivery Time</span></a> -->
              <a @click="back" href="javascript:void(0)"><span>Home</span></a>
            </div>
            <div @click="contact_us" class="selectright">
              <div><span>Contact Us Now</span></div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="bgtwo">
      <div class="productList">

        <!-- 侧边导航栏 -->
        <div class="sidebar">
          <el-row class="tac">
            <el-col :span="20">
              <el-menu
                  unique-opened
                  class="el-menu-vertical-demo"
                  @select="handSelect">
                <template v-for="item in this.navigation">
                  <!--一级目录开始-->
                  <template v-if="item.sub">
                    <el-submenu :index="item.id.toString()" :key="item.id">
                      <template slot="title">
                        <!--<i class="el-icon-location"></i>-->
                        <span>{{ item.name }}</span>
                      </template>

                      <template v-for="subItem of item.sub">
                        <!--二级目录开始-->
                        <el-submenu v-if="subItem.sub" :index="subItem.id.toString()" :key="subItem.id">
                          <template slot="title">{{ subItem.name }}</template>
                          <template v-for="threeItem of subItem.sub">
                            <!--三级目录开始-->
                            <el-submenu v-if="threeItem.sub" :index="subItem.id.toString()" :key="threeItem.id">
                              <template slot="title">{{ threeItem.name }}</template>

                              <template v-for="fourItem of threeItem.sub">
                                <!--四级目录-->
                                <el-menu-item :index="fourItem.id.toString()" :key="fourItem.id">{{ fourItem.name }}</el-menu-item>
                              </template>
                            </el-submenu>
                            <el-menu-item v-else :index="threeItem.id.toString()" :key="threeItem.id">{{ threeItem.name }}
                            </el-menu-item>
                            <!--三级目录结束-->
                          </template>
                        </el-submenu>
                        <el-menu-item v-else :index="subItem.id.toString()" :key="subItem.id">{{ subItem.name }}</el-menu-item>
                        <!--二级目录结束-->
                      </template>
                    </el-submenu>
                  </template>
                  <template v-else>
                    <el-menu-item :index="item.id.toString()" :key="item.id">
                      <!--<i class="el-icon-menu"></i>-->
                      <span slot="title">{{ item.name }}</span>
                    </el-menu-item>
                  </template>
                  <!--一级目录结束-->
                </template>
              </el-menu>
            </el-col>
          </el-row>
        </div>


        <div class="product">
          <el-row :gutter="20">
            <el-col
                :span="8"
                v-for="(item, index) in this.pd_list"
                :key="item.id"
            >
              <div class="grid-content bg-purple">
                <div class="clothing">
                  <div
                      class="clothing-center"
                      @mouseenter="show['show' + index] = !show['show' + index]"
                      @mouseleave="show['show' + index] = !show['show' + index]"
                  >
                    <div class="CL-top">
                      <img :src="item.image" alt="" />
                      <transition name="el-zoom-in-center">
                        <div v-show="show['show' + index]">
                          <el-button type="primary" @click="pdview(index)"
                          >VIEW PRODUCT</el-button
                          >
                        </div>
                      </transition>
                    </div>
                    <div class="content-product">
                      <p class="title">{{ item.title }}</p>
                      <div class="price">{{ item.price }}</div>
                    </div>
                    <div class="box-size">
                      <ul>
                        <li v-for="ite in item.sizes" :key="ite.id">
                          {{ ite.content }}
                        </li>
                      </ul>
                    </div>
                    <div class="box-color">
                      <ul>
                        <template v-for="(it, index) in item.colors">
                          <li
                              v-if="index < 5"
                              :key="it.id"
                              :style="{ 'background-color': it.content }"
                          ></li>
                        </template>
                        <p class="more">+ {{ item.colors.length }} colors</p>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </el-col>

          </el-row>
          <!-- 翻页 -->
          <el-pagination
              @current-change="handleSizeChange"
              background layout="prev, pager, next"
              :total="total"
              :page-size="limit">
          </el-pagination>
        </div>
      </div>
      <!-- 点击产品弹窗信息 -->
      <div class="view">
        <el-dialog :visible.sync="productCenterDialogVisible" center>
          <div class="left-img">
            <img :src="this.viewList.image" alt="" />
          </div>
          <div class="right-content">
            <div class="s-title">{{ this.viewList.title }}</div>
            <div class="s-price">${{ this.viewList.price }}</div>
            <div class="s-content">
              <ul>
                <li v-for="item in this.viewList.descriptions" :key="item.id">
                  {{ item.content }}
                </li>
              </ul>
            </div>
            <div class="s-size">
              <h1>SIZE:</h1>
              <ul>
                <li v-for="ite in this.viewList.sizes" :key="ite.id">
                  {{ ite.content }}
                </li>
              </ul>
            </div>
            <div class="s-color">
              <h1>COLOR:</h1>
              <ul>
                <li
                    v-for="its in viewList.colors"
                    :key="its.id"
                    :style="{ 'background-color': its.content }"
                ></li>
              </ul>
            </div>
          </div>
        </el-dialog>
      </div>

    </div>

    <div class="bgnine">
      <div class="centeNine">
        <div class="foot">
          <div class="footOne">
            <img src="../../assets/img/logo1.svg" alt="" />
            <div class="webfba">
              Webfba –
              We are the All-In-One Dropshipping agent who helps you source and ship anything you need, such as general cargo, liquid, sensitive cargo, what more, we also offer POD service, One-piece also can be customized.
            </div>
          </div>
          <div class="footTwo">
            <div class="footTwoTitle">What we offer</div>
            <div class="footTwoContent">
              <ul>
                <li class="about-us" @click="rot('services',3)">Services</li>
                <li @click="rot('services',4)">POD</li>
                <li @click="product">Product</li>
                <li @click="rot('services',6)">Price</li>
                <li  @click="rot('services',6)">Delivery</li>
                <li  @click="rot('services',6)">Time</li>
                <li  @click="rot('services',8)">Processing</li>
              </ul>
            </div>
          </div>
          <div class="footThree">
            <div class="footThreeTitle">Our Company</div>
            <div class="footThreeContent">
              <ul>
                <li @click="abous">About Us</li>
                <li  @click="rot('services',6)">Why Us？</li>
                <el-button
                    class="contact"
                    type="text"
                    @click="contact_us"
                ><li class="contact_us">Contact Us</li></el-button
                >
              </ul>
            </div>
          </div>
          <div class="footFour">
            <!-- <div class="footFourTitle">Need help?</div>
            <div class="footFourContent">
              <ul>
                <el-button
                  class="contact"
                  type="text"
                  @click="centerDialogVisible = true"
                  ><li class="contact_us">Contact Us</li></el-button
                >

                <li>Help Center</li>
                <li>FAQs</li>
              </ul>
            </div> -->
            <!-- 点击底部contact us弹窗 邮箱链接-->
            <el-dialog
                title="Contact US"
                :visible.sync="centerDialogVisible"
                width="40%"
                center
            >
              <a
                  href="https://mail.google.com/mail/u/0/?fs=1&tf=cm&source=mailto&to=support@webfba.com"
                  style="float: left"
              ><div
                  style="
                    float: left;
                    display: inline;
                    font-size: 2.5rem;
                    line-height: 4rem;
                  "
              >
                click:
              </div>
                <img
                    src="../../assets/img/logo_gmail.png"
                    alt=""
                    style="width: 10rem; height: 4rem; float: right"
                /></a>
              <span slot="footer" class="dialog-footer">
                <!-- <el-button @click="centerDialogVisible = false">取 消</el-button> -->
                <!-- <el-button type="primary" @click="centerDialogVisible = false">确 定</el-button> -->
              </span>
            </el-dialog>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Bus from '../../assets/js/bus';
export default {
  name: "Abous_us",
  data() {
    return {
      centerDialogVisible: false,
      productCenterDialogVisible:false,
      msg: "Product",
      pd_list: [],
      navigation: [],
      total:0,

      category_id: 0,
      page: 1,
      limit: 21,
      show: {},
      viewList: {},
    };
  },
  created() {
    this.categories();
    this.pd_views();
  },
  methods: {
    abous() {
      this.$router.push({ path: "/Abous_us" });
    },
    product() {
      this.$router.push({ path: "/products" });
    },
    contact_us() {
      this.$router.push({ path: "/contact_us" });
    },
    rot(event,index){
      this.$router.push({ path: "/" });
      Bus.$emit(event,index);

    },
    back() {
      this.$router.go(-1);
      //  this.$router.push({ path: "./" });返回主页顶部
    },
    // 点击导航栏回调事件

    handSelect(index, indexPath) {
      console.log(index, indexPath);
      this.category_id = index;
      this.page= 1;
      this.pd_views();
    },

    // 导航栏请求数据
    categories() {
      this.http
          .fetchGet(this.api.categories)
          .then((res) => {
            this.navigation = res.data.data;
            // console.log(this.navigation, "777");
          })
          .catch((err) => {
            console.log(err);
          });
    },
    // 请求产品数据
    pd_views() {
      let pd_lists = {
        category_id: this.category_id,
        page: this.page,
        limit: this.limit,
      };
      this.http
          .fetchGet(this.api.pd_list, pd_lists)
          .then((res) => {
            let data=res.data.data
            this.pd_list = data.data;
            this.total = data.total
            //给显示隐藏按钮单独一个值
            let showDemo = {};
            for (let inde = 0; inde < this.pd_list.length; inde++) {
              // var str="show"
              showDemo["show" + inde] = false;
            }

            this.show = showDemo;
            // console.log(showDemo,"666")
            // console.log(this.pd_list, "777");
          })
          .catch((err) => {
            console.log(err);
          });
    },
    // 点击产品弹窗的数据
    pdview(index) {
      // this.productCenterDialogVisible = true;
      // this.viewList = this.pd_list[index];
      this.$router.push({ path: "/productsDetail/"+this.pd_list[index]['id'] });
    },
    // 翻页数据
    handleSizeChange(val){
      this.page = val;
      this.pd_views();
    }

  },
};
</script>
<style lang='stylus' scoped>
@import '~@/assets/css/varibles.styl';

.content_main {
  width: 100%;
  height: 100%;
  font-size: 62.5%;
  min-width: 127rem;

.bgone {
  width: 100%;
  height: 10rem;
  position: fixed;
  top: 0px;
  z-index: 9999;
// backdrop-filter: saturate(180%) blur(6px);
  background-color: rgba(7, 17, 27, 0.5);
// filter: opacity(.3);
  background-color: var(--header-background);
  background-color: #FFFFFF;
  box-shadow: 3rem 0px 4rem #EEE;

// background-image: linear-gradient(#ff7300, #FFFF);
.centerOne {
  width: 120rem;
  margin: 0 auto;

// background-color: greenyellow;
.head {
.firmlogo {
  float: left;
  width: 30.2rem;
  height: 8.1rem;
  margin-top: 1rem;

.firmlogoright {
  float: left;
  width: 26.1rem;
  height: 8.1rem;
  margin-left: -4rem;

img {
  width: 100%;
  height: 100%;
}
}
}

.topright {
  float: right;
  margin-top: 3.1rem;

.selectleft {
  width: 6 0rem;
  float: left;

span {
  display: inline-block;
  font-size: 1.6rem;
  color: #333333;
  margin-left: 4rem;
  font-weight: bold;
  line-height: 4rem;
}

// .onespan {
   // margin-left: 0;
   // }
span:hover {
  color: #FF7300;
}
}

.selectright {
  float: right;
// margin-top:0.5rem;
  background-color: #FF7300;
  border-radius: 0.2rem;
  margin-left: 4rem;
  width: 14rem;
  height: 4rem;
  font-weight: 10rem;

div {
  text-decoration: none;

span {
  display: block;
  color: #FFFFFF;
  font-size: 1.6rem;
  text-align: center;
  font-weight: bold;
  line-height: 4rem;
}
}

span:hover {
  color: #333333;
}
}
}
}
}
}

.bgtwo {
  margin-top: 14rem;

.centertwo {
  width: 90rem;
  margin: 0 auto;

.bgtwo_title {
  font-size: 30px;
  font-weight: 900;
  text-align: center;
  margin-bottom: 10px;
}

.abous_us {
p {
  font-size: 20px;
  line-height: 40px;
  color: #888;
}

.top-line {
  margin-top: 4rem;

.line {
  border: 2px red solid;
  width: 3.5rem;
}

.abous_title {
  font-size: 21px;
  font-weight: bold;
  color: black;
}
}
}
}
}

.bgnine {
  float: left;
  width: 100%;
  height: 35rem;
  background-color: #18252D;
  margin-top: 9.4rem;

.centeNine {
  width: 120rem;
  margin: 0 auto;

.foot {
.footOne {
  width: 40rem;
// height: 5.2rem;
  float: left;
  margin-top: 6rem;

img {
  width: 30%;
}

.webfba {
  color: #FFFFFF;
  font-size: 1.4rem;
  line-height: 3rem;
  font-weight: bold;
  display: inline-block;
}
}

.footTwo {
  widows: 100%;
  width: 13rem;
  float: left;
  margin-top: 6.7rem;
  margin-left: 20rem;

.footTwoTitle {
  font-size: 1.8rem;
  color: #FF7300;
  font-weight: bold;
  float: left;
}

.footTwoContent {
ul {
  margin: 0;
  padding: 0;

li {
  widows: 100%;
  list-style: none;
  font-size: 1.4rem;
  color: #FFFFFF;
  line-height: 3rem;
  font-weight: bold;
// display: inline-block;

// a {
   //   color: #FFFFFF;
   // }

// a:hover {
   //   color: #FF7300;
   // }
}
li:hover{
  color: #FF7300;
  cursor:pointer;
}
}
}
}

.footThree {
  width: 20rem;
  float: left;
  margin-top: 6.7rem;
  margin-left: 25rem;

.footThreeTitle {
  font-size: 1.8rem;
  color: #FF7300;
  font-weight: bold;
  float: left;
  width: 100%;
}

.footThreeContent {
ul {
  margin: 0;
  padding: 0;

li {
  width: 100%;
  list-style: none;
  font-size: 1.4rem;
  color: #FFFFFF;
  line-height: 3rem;
  font-weight: bold;
  display: inline-block;
}
li:hover{
  color: #FF7300;
  cursor:pointer;
}
.contact{
  padding:0;
}
}
}
}

.footFour {
  width: 10rem;
  float: right;
  margin-top: 6.7rem;

.footFourTitle {
  font-size: 1.8rem;
  color: #FF7300;
  font-weight: bold;
  float: left;
  widows: 100%;
}

.footFourContent {
ul {
  margin: 0;
  padding: 0;

li {
  widows: 100%;
  list-style: none;
  font-size: 1.4rem;
  color: #FFFFFF;
  line-height: 3rem;
  font-weight: bold;
  display: inline-block;
}

.contact {
  padding: 0;
}

.contact_us:hover {
  color: #FF7300;
}
}
}
}
}
}
}
}

/* preview */
.view {
.el-dialog {
.left-img {
  float: left;
  width: 16rem;
  height: 16rem;

img {
  width: 100%;
  height: 100%;
}
}

.right-content {
  float: right;
  width: 65%;

.s-title {
  font-size: 1.8rem;
  font-weight: 600;
  color: #0f5f9a;
}
}

.s-price {
  font-size: 1.5rem;
  font-weight: 600;
  color: #e61454;
}

.s-content {
// height: 20rem;
// overflow: hidden;
ul {
  margin-left: 2rem;

li {
  list-style-type: disc;
}
}
}

.s-size {
  margin-top: 1rem;

h1 {
  display: inline-block;
  font-weight: 600;
  font-size: 14px;
}

ul {
  display: inline-block;

li {
  display: inline-block;
// width: 2rem;
  padding: 0.2rem;
  height: 2.0rem;
  background-color: #282828;
  text-align: center;
  line-height: 2.0rem;
  border-radius: 3px;
  margin-left: 0.5rem;
  color: #fff;
}
}
}

.s-color {
  margin-top: 1rem;

h1 {
  display: inline-block;
  font-weight: 600;
  font-size: 14px;
}

ul {
  display: inline-block;

li {
  display: inline-block;
  width: 2.2rem;
  height: 2.2rem;
  background-color: #282828;
  border-radius: 2px;
  margin-left: 0.3rem;
}
}
}
}
}

.view >>>.el-dialog {
  width: 60rem !important;
  height: 40rem;

.el-dialog__body {
  height: 70%;

}
}
/* product */
.productList {
  height: 100%;
  margin: 0 auto;
  max-width: 63%;
.el-pagination{
  position: relative;
}
.sidebar {
  display: inline-block;
  width: 25%;
  margin-bottom: 5rem;
  box-shadow: 3rem 3rem 3rem 3rem #EEE;
.el-menu-item {
  min-width: 0;
}
}

.product {
  margin-bottom: 1rem;
  text-align: center;
  display: inline-block;
  width: 70%;
  float: right;
.bg-purple {
  /*background: #d3dce6;*/
  background: #fff;
  margin-bottom: 10px;
  box-shadow: 3rem 3rem 3rem 4rem #EEE;
}
.clothing:hover {
  border: 1px solid #0f5f9a;
}

.clothing {
  border: 1px solid transparent;

.clothing-center {
  width: 100%;
  height: 35rem;
.CL-top {
  width: 100%;
  height: 60%;
  position: relative;
  box-sizing: border-box;
  padding: 0 1rem;
  padding-top: 1rem;

// overflow: hidden;
img {
  width: 20rem;
  height: 20rem;
}
}

.content-product {
.title {
// margin-top: 1rem;
  text-align: center;
  height: 2.5rem;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp:2;

}

.price {
  color: #e61454;
  font-size: 1.5rem;
  font-weight: 600;
}
}

.box-size {
  margin-top: 0.5rem;

ul {
// height: 1.2rem;
// overflow: hidden;
li {
  display: inline-block;
  border-radius: 2.5px;
  padding: 0.2rem;
  background-color: #282828;
  margin-left: 0.3rem;
  margin-top: 0.3rem;
  color: #fff;
  text-align: center;
}
}
}

.box-color {
  margin-top: 1rem;

ul {
  padding: 0;
  margin: 0;
  list-style: none;

li {
  display: inline-block;
  margin-left: 0.3rem;
  width: 1.5rem;
  height: 1.5rem;
  background-color: #dd74a1;
  border-radius: 3px;
}

.more {
  width: auto;
  /*background-color: #d3dce6;*/
}
}
}
}
}
}
}
</style>
